<template>
  <div class="alert" :class="alertClass" role="alert" v-if="type">
    <span class="fas" :class="iconClass"></span> {{message}}
  </div>
</template>

<script>
  import EventBus from '@/utils/EventBus'

  export default {
    computed: {
      alertClass () {
        return `alert-${this.type}`
      },
      iconClass () {
        switch (this.type) {
          case 'danger': return 'fa-times-circle'
          case 'warning': return 'fa-exclamation-circle'
          case 'info': return 'fa-info-circle'
          case 'success': return 'fa-check-circle'
          default: return 'fa-info-circle'
        }
      }
    },
    data () {
      return {
        message: '',
        type: ''
      }
    },
    methods: {
      hideNotification () {
        this.type = null
      },
      showNotification (type, msg) {
        this.type = type
        this.message = msg
      }
    },
    mounted () {
      EventBus.$on('show-notification', this.showNotification)
      EventBus.$on('hide-notification', this.hideNotification)
    }
  }
</script>

<style lang="scss">
  @import '@/sass/variables.scss';

  .alert-danger {
    background-color: transparentize(lighten($el-salmon, 30%), .92);
    border-color: transparentize($el-salmon, .8);
    color: $el-salmon;
  }

  .alert-info {
    background-color: transparentize($cyan, .92);
    border-color: transparentize($cyan, .7);
    color: darken($cyan, 10%);
  }

  .alert-success {
    background-color: transparentize($green, .94);
    border-color: transparentize($green, .6);
    color: darken($green, 15%);
  }

  .alert-warning {
    background-color: transparentize(lighten($yellow, 15%), .85);
    border-color: transparentize($yellow, .5);
    color: darken($yellow, 20%)
  }
</style>
